import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Resolve and merge multiple class name inputs into a single Tailwind-safe class string.
 *
 * @param inputs - Class name values (strings, arrays, or conditional objects) to combine
 * @returns The resulting class string with duplicate classes removed and Tailwind class conflicts resolved
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number as Brazilian Real currency.
 *
 * @param value - The numeric amount to format
 * @returns The input formatted as a currency string in `pt-BR` locale using `BRL`
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}
